// create a type as an array with possible values
export const AgentSections = [
  '/',
  '/people',
  '/conversations',
  '/opportunities',
  '/pipeline',
  '/sales'
]
